import { useEffect } from 'react'

import { TaxonomyType } from 'generated/graphql'
import { useWorkspaceCompanyPlan } from 'hooks/useWorkspaceCompanyPlan'
import { FeatureFlagsStore } from 'stores'

import { WORKSPACE_GET_COMPANY_PLAN_LOG_ERROR } from './use-is-global-taxonomy.consts'

export const useIsGlobalTaxonomy = () => {
  const {
    workspaceTaxonomyType,
    getWorkspaceCompanyPlanFromApi,
    workspaceCompanyPlanLoading,
    workspaceCompanyPlanCalled,
  } = useWorkspaceCompanyPlan({
    errorLog: WORKSPACE_GET_COMPANY_PLAN_LOG_ERROR,
  })

  const isGlobalTaxonomyWorkspace = workspaceTaxonomyType === TaxonomyType.Country
  const isGlobalTaxonomyEnabled =
    isGlobalTaxonomyWorkspace && FeatureFlagsStore.isFeatureFlagEnabled('isGlobalTaxonomyEnabled')
  const isQueryInformationAvailable = workspaceCompanyPlanCalled && !workspaceCompanyPlanLoading

  useEffect(() => {
    getWorkspaceCompanyPlanFromApi()
  }, [getWorkspaceCompanyPlanFromApi])

  return {
    isGlobalTaxonomyWorkspace,
    isGlobalTaxonomyEnabled,
    isQueryInformationAvailable,
  }
}
